export const PARKING_LOADING = "scooter/parking/loading";
export const PARKING_ERROR = "scooter/parking/error";
export const PARKING_LIST = "scooter/parking/list";



// WEBPACK FOOTER //
// ./src/actions/scooter/parking/constants.js